import { parse, stringify } from 'query-string';

/**
 * Parses URL to look for specific query parameters and returns
 * an object containing the key/values.  Keys are whitelisted
 * based on what is passed in as the `allowed` parameter
 *
 * @param {string[]} allowed whitelisted keys
 * @returns an object or undefined
 */
export const parseQueryString = (allowed: string[] = []): object | undefined => {
  const { search } = window.location;
  if (search) {
    const raw = parse(search);
    return Object.keys(raw)
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        obj[key] = raw[key];
        return obj;
      }, {});
  }
  return undefined;
};

/**
 * Stringify an object into a query string, sorting the keys.
 *
 * @param {object} obj
 * @returns {string}
 */
export const generateQueryString = (obj: object): string => {
  if (!obj) {
    return '';
  }
  return stringify(obj);
};